import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { HostListener, Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() public collapsed: boolean = false;

    public modules: any[] = [
        {
            title: '예진',
            link: '/dashboard?panel=intake',
            panel: 'intake',
            iconPath: 'M8.25 4.5h7.5A2.25 2.25 0 0 1 18 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 6 17.25V6.75A2.25 2.25 0 0 1 8.25 4.5ZM9 9h6M9 12h6M9 15h3'
        },
        {
            title: '진료',
            link: '/dashboard?panel=clinic',
            panel: 'clinic',
            iconPath: 'M12 6v12M18 12H6M5.25 5.25h13.5v13.5H5.25V5.25Z'
        },
        {
            title: '기록',
            link: '/dashboard?panel=evidence',
            panel: 'evidence',
            iconPath: 'M7.5 4.5h6L18 9v10.5H6V4.5h1.5ZM13.5 4.5V9H18M8.25 13.5h7.5M8.25 16.5h5.25'
        },
        {
            title: '재진',
            link: '/dashboard?panel=revisit',
            panel: 'revisit',
            iconPath: 'M12 6v6l3.75 2.25M21 12a9 9 0 1 1-2.64-6.36'
        }
    ];

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(item: any) {
        const panel = new URLSearchParams(location.search).get('panel') || 'intake';
        return location.pathname === '/dashboard' && panel === item.panel;
    }

    public brandClass() {
        if (this.collapsed) {
            return "flex h-10 w-10 items-center justify-center rounded-lg transition hover:bg-white";
        }
        return "group flex min-w-0 flex-1 cursor-pointer items-center gap-3 rounded-lg border border-zinc-200 bg-white p-2.5 shadow-sm transition hover:border-[#b8cbc4]";
    }

    public activeClass(item: any) {
        if (this.collapsed) {
            if (this.isActive(item)) {
                return "group flex h-10 w-10 items-center justify-center rounded-lg border border-[#9ebbb2] bg-white text-[#243f3b] shadow-sm";
            }
            return "group flex h-10 w-10 items-center justify-center rounded-lg border border-transparent text-zinc-500 transition hover:border-zinc-200 hover:bg-white hover:text-[#243f3b]";
        }
        if (this.isActive(item)) {
            return "group relative flex items-center gap-2 rounded-lg border border-[#b8cbc4] bg-white px-2.5 py-2.5 text-[13px] font-medium text-[#243f3b] shadow-sm";
        }
        return "group relative flex items-center gap-2 rounded-lg border border-transparent px-2.5 py-2.5 text-[13px] font-medium text-zinc-600 transition hover:border-zinc-200 hover:bg-white hover:text-[#243f3b]";
    }

    public stepClass(item: any) {
        if (this.collapsed) {
            if (this.isActive(item)) {
                return "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[#2f6f66] text-[12px] font-semibold text-white";
            }
            return "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-zinc-100 text-[12px] font-semibold text-zinc-500 group-hover:bg-[#eef4f1] group-hover:text-[#2f6f66]";
        }
        if (this.isActive(item)) {
            return "flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[#2f6f66] text-[12px] font-semibold text-white";
        }
        return "flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-zinc-100 text-[12px] font-semibold text-zinc-500 group-hover:bg-[#eef4f1] group-hover:text-[#2f6f66]";
    }
}

export default ComponentNavSidebarComponent;